var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card my-3 p-3" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-8 pb-3" }, [
        _vm._v("\n      What do "),
        _c("a", { attrs: { target: "_blank", href: _vm.anzscoUrl } }, [
          _c("b", [_vm._v(_vm._s(_vm.classificationItemData["title"]))])
        ]),
        _vm._v(" do? "),
        _c("small", [_vm._v("ANZSCO code: " + _vm._s(_vm.code))]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("span", {
          domProps: {
            innerHTML: _vm._s(
              _vm.classificationItemData["explanatoryNotes"].trunc(250)
            )
          }
        }),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "jump-link",
            attrs: { target: "_blank", href: _vm.anzscoUrl }
          },
          [
            _vm._v(
              "\n        See more about this job, and its skills, tasks and tools.\n        "
            ),
            _c("i", { staticClass: "fas fa-external-link-alt" })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-4" },
        [
          _c("PayGraphSection", {
            attrs: {
              "anzsco-code": _vm.classificationItemData["code"],
              "compare-code": _vm.compareCode
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.mainOccupation
      ? _c("div", [
          _c("b", [_vm._v("Top 10 Main Skills for this job")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "skills-list" },
            _vm._l(_vm.mainSkills, function(item) {
              return _c("span", { key: item["targetItem"]["title"] }, [
                _c(
                  "span",
                  { staticClass: "badge badge-info smallskill mr-2" },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          target: "_blank",
                          href:
                            "https://aristotle-te-govhack-20-qrjjxm.herokuapp.com/redirect/to/classificationitem/" +
                            item["uuid"]
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(item["targetItem"]["title"]) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              ])
            }),
            0
          )
        ])
      : _c("div", [
          _c("b", [_vm._v("Skills you might have and can use in this job")]),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "skills-list" },
            _vm._l(_vm.similarSkills, function(item) {
              return _c("span", { key: item["title"] }, [
                _c(
                  "span",
                  { staticClass: "badge badge-info smallskill mr-2" },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          target: "_blank",
                          href:
                            "https://aristotle-te-govhack-20-qrjjxm.herokuapp.com/redirect/to/classificationitem/" +
                            item["uuid"]
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(item["title"]) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              ])
            }),
            0
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }